(function() {
  var FULFILLMENT_ATTRS = ['_availability', '_shipment_group', '_item_shipping_surcharge', '_expected_ship_date'];
  var ET_TIMEZONE = 'America/New_York';

  function getEtDateParts(date) {
    var formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: ET_TIMEZONE,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
    var parts = {};
    formatter.formatToParts(date).forEach(function(part) {
      if (part.type !== 'literal') {
        parts[part.type] = part.value;
      }
    });
    return parts;
  }

  function formatYmdFromParts(parts) {
    return parts.year + '-' + parts.month + '-' + parts.day;
  }

  function parseYmd(ymd) {
    var bits = ymd.split('-');
    return { year: parseInt(bits[0], 10), month: parseInt(bits[1], 10), day: parseInt(bits[2], 10) };
  }

  function ymdToDate(ymd) {
    var p = parseYmd(ymd);
    return new Date(p.year, p.month - 1, p.day);
  }

  function formatYmdFromDate(date) {
    var y = date.getFullYear();
    var m = String(date.getMonth() + 1).padStart(2, '0');
    var d = String(date.getDate()).padStart(2, '0');
    return y + '-' + m + '-' + d;
  }

  function isWeekendYmd(ymd) {
    var day = ymdToDate(ymd).getDay();
    return day === 0 || day === 6;
  }

  function buildClosureSet(closureDates) {
    var set = new Set();
    (closureDates || []).forEach(function(entry) {
      if (entry) {
        set.add(String(entry).slice(0, 10));
      }
    });
    return set;
  }

  function isBusinessDay(ymd, closureSet) {
    return !isWeekendYmd(ymd) && !closureSet.has(ymd);
  }

  function addDaysYmd(ymd, days) {
    var date = ymdToDate(ymd);
    date.setDate(date.getDate() + days);
    return formatYmdFromDate(date);
  }

  function nextBusinessDay(fromYmd, closureSet) {
    var cursor = fromYmd;
    do {
      cursor = addDaysYmd(cursor, 1);
    } while (!isBusinessDay(cursor, closureSet));
    return cursor;
  }

  function getExpectedShipDate(closureDates) {
    var closureSet = buildClosureSet(closureDates);
    var etParts = getEtDateParts(new Date());
    var today = formatYmdFromParts(etParts);
    var hour = parseInt(etParts.hour, 10);

    if (isBusinessDay(today, closureSet) && hour < 8) {
      return today;
    }
    return nextBusinessDay(today, closureSet);
  }

  function normalizeShippingRules(raw) {
    if (raw == null || raw === '') {
      return '';
    }
    if (Array.isArray(raw)) {
      return raw.filter(Boolean).join(' ').toLowerCase();
    }
    return String(raw).toLowerCase();
  }

  // Same rule as the checkout extension (schneiders-app delivery-date-display):
  // only the variant's sync.availability_status makes a line backordered, never
  // a restock date alone, because the sync also writes restock dates on in-stock
  // variants. A backordered line promises its restock date only when that date is
  // after today (Eastern); otherwise it promises nothing.
  var BACKORDERED_STATUSES = ['backorder', 'temporarily_oos'];

  function usableRestockDate(restockDate) {
    var ymd = restockDate ? String(restockDate).trim() : '';
    if (!/^\d{4}-\d{2}-\d{2}$/.test(ymd)) {
      return '';
    }
    return ymd > formatYmdFromParts(getEtDateParts(new Date())) ? ymd : '';
  }

  function computeLineAttributes(lineConfig, expectedShipDate) {
    var rules = normalizeShippingRules(lineConfig.shippingRules);
    var availability;
    var shipmentGroup;
    var shipDate = expectedShipDate;

    if (BACKORDERED_STATUSES.indexOf(lineConfig.availabilityStatus) !== -1) {
      availability = 'backordered';
      shipmentGroup = 'backordered';
      shipDate = usableRestockDate(lineConfig.restockDate);
    } else if (rules.indexOf('freight quote required') !== -1 || rules.indexOf('ltl required') !== -1) {
      availability = 'freight_quote';
      shipmentGroup = 'freight';
    } else if (lineConfig.isDropShip) {
      availability = 'ships_direct';
      shipmentGroup = 'drop_ship';
    } else {
      availability = 'in_stock';
      shipmentGroup = 'warehouse';
    }

    var surcharge = 0;
    if (lineConfig.surchargeRaw !== null && lineConfig.surchargeRaw !== undefined && lineConfig.surchargeRaw !== '') {
      var dollars = parseFloat(lineConfig.surchargeRaw);
      if (!isNaN(dollars)) {
        surcharge = Math.round(dollars * 100);
      }
    }

    return {
      _availability: availability,
      _shipment_group: shipmentGroup,
      _item_shipping_surcharge: String(surcharge),
      _expected_ship_date: shipDate
    };
  }

  function readConfig(root) {
    var scope = root || document;
    var el = scope.querySelector ? scope.querySelector('#fulfillment-cart-config') : null;
    if (!el) {
      return null;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      console.error('FulfillmentCartWriter: invalid config JSON', error);
      return null;
    }
  }

  function propsNeedUpdate(existing, expected) {
    for (var i = 0; i < FULFILLMENT_ATTRS.length; i++) {
      var key = FULFILLMENT_ATTRS[i];
      if (String((existing && existing[key]) || '') !== String(expected[key] || '')) {
        return true;
      }
    }
    return false;
  }

  function resolveLineConfig(item, config, usedConfigKeys) {
    if (config.lines[item.key]) {
      usedConfigKeys.push(item.key);
      return config.lines[item.key];
    }

    var fallback = null;
    Object.keys(config.lines).some(function(configKey) {
      if (usedConfigKeys.indexOf(configKey) !== -1) {
        return false;
      }
      var lineConfig = config.lines[configKey];
      if (lineConfig.variantId === item.id) {
        fallback = lineConfig;
        usedConfigKeys.push(configKey);
        return true;
      }
      return false;
    });

    return fallback;
  }

  function setExpressButtonsPending(root, pending) {
    var scope = root || document;
    if (!scope.querySelectorAll) {
      return;
    }
    scope.querySelectorAll('.additional-checkout-buttons').forEach(function(el) {
      if (pending) {
        el.classList.add('fulfillment-pending');
        el.setAttribute('aria-hidden', 'true');
      } else {
        el.classList.remove('fulfillment-pending');
        el.removeAttribute('aria-hidden');
      }
    });
  }

  function mountSideCartTemplate() {
    var tpl = document.getElementById('additional_checkout_buttons_tpl');
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) {
      return;
    }
    tpl.insertAdjacentElement('afterend', tpl.content.firstElementChild);
    tpl.parentNode.removeChild(tpl);
  }

  async function ensureReady(root) {
    var config = readConfig(root);
    if (!config || !config.lines) {
      return { ok: true, cartHasFreight: false, updated: false };
    }

    var lineKeys = Object.keys(config.lines);
    if (lineKeys.length === 0) {
      return { ok: true, cartHasFreight: !!config.cartHasFreight, updated: false };
    }

    var expectedShipDate = getExpectedShipDate(config.closureDates);
    var cart = await $s.getJson({ url: '/cart.js' });
    var usedConfigKeys = [];
    var updates = [];

    cart.items.forEach(function(item) {
      var lineConfig = resolveLineConfig(item, config, usedConfigKeys);
      if (!lineConfig) {
        return;
      }
      var expected = computeLineAttributes(lineConfig, expectedShipDate);
      if (propsNeedUpdate(item.properties || {}, expected)) {
        updates.push({
          key: item.key,
          quantity: item.quantity,
          properties: Object.assign({}, item.properties || {}, expected)
        });
      }
    });

    if (updates.length === 0) {
      return { ok: true, cartHasFreight: !!config.cartHasFreight, updated: false };
    }

    for (var i = 0; i < updates.length; i++) {
      var update = updates[i];
      await $s.post({
        type: 'POST',
        url: routes.cart_url + '/change.js',
        data: {
          id: update.key,
          quantity: update.quantity,
          properties: update.properties
        },
        dataType: 'json'
      });
    }

    if (window.CartCache && typeof window.CartCache.newCart === 'function') {
      window.CartCache.newCart();
    }

    return { ok: true, cartHasFreight: !!config.cartHasFreight, updated: true };
  }

  async function run(root) {
    var config = readConfig(root);
    if (!config) {
      return { ok: true, cartHasFreight: false };
    }

    setExpressButtonsPending(root, true);

    try {
      var result = await ensureReady(root);
      if (!result.cartHasFreight) {
        setExpressButtonsPending(root, false);
      }
      return result;
    } catch (error) {
      console.error('FulfillmentCartWriter', error);
      return { ok: false, cartHasFreight: !!config.cartHasFreight };
    }
  }

  window.FulfillmentCartWriter = {
    run: run,
    ensureReady: ensureReady,
    mountSideCartTemplate: mountSideCartTemplate,
    setExpressButtonsPending: setExpressButtonsPending
  };
})();
